import React, { useContext } from 'react'
import { MeetingsContext } from '../../../context/MeetingContext'
import { formatDateHMMSS } from '../../../utils/formatDate'
import PropTypes from 'prop-types'

export function QATooltip({ id, content, facilitatorQuestion, participantId, whoSaidIt, startTime }) {
  const { setScrollToQA, participants } = useContext(MeetingsContext)

  return (
    <div className="w-[300px] text-left flex flex-col gap-[6px]">
      <p className="font-bold text-[16px] font-['Manrope']">Q: {facilitatorQuestion}</p>
      <p className="font-normal text-[14px] font-['Manrope']">A: {content}</p>
      <div className="flex items-center">
        <p className="font-semibold text-[14px] font-['Manrope']">
          {participantId ? participants[participantId]?.name : whoSaidIt} @ {formatDateHMMSS(startTime)}・
        </p>
        <button className="font-semibold text-[14px] font-['Manrope'] text-linkBlue" onClick={() => setScrollToQA(id)}>
          See Interview at a Glance ❯
        </button>
      </div>
    </div>
  )
}

QATooltip.propTypes = {
  id: PropTypes.string,
  content: PropTypes.string,
  facilitatorQuestion: PropTypes.string,
  participantId: PropTypes.string,
  whoSaidIt: PropTypes.string,
  startTime: PropTypes.number,
}
